var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.details)?_c('div',{staticClass:"message-preview"},[(!_vm.opponentMessage)?_c('span',{staticClass:"message-preview__author"},[_vm._v(_vm._s(_vm.$t("You"))+": ")]):_vm._e(),_c('format-money',{attrs:{"cost":_vm.details.amount,"hideNumberSymbol":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var amount = ref.amount;
var symbol = ref.symbol;
var separator = ref.separator;
return [_c('span',[_vm._v(_vm._s(_vm.$t("I sent you a {0} tip!", [("" + symbol + (amount[0]) + separator + (amount[1]))])))])]}}],null,false,2503113857)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }